import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AttachFileIcon from "@mui/icons-material/AttachFile";
const ViewAllAttachments = (props) => {
    return (_jsxs("div", { children: [_jsx("h2", { children: "Attachments" }), props.secureMessage.Attachments &&
                props.secureMessage.Attachments.map((file) => (_jsxs("div", { children: [_jsx(AttachFileIcon, {}), file?.FileName] }, file?.Id)))] }));
};
export default ViewAllAttachments;
